import FormContainer from '@components/form/container'
import FormSignatureHistories from '@components/form/signatureHistories'
import { GlobalStateProps } from '@providers/globalStore'
import { FormCRModel } from '@services/model/form/form.CR.model'
import { Control, useWatch } from 'react-hook-form'

export default ({
  globalState,
  control,
  handleOnComplete,
}: {
  globalState: GlobalStateProps
  control: Control<FormCRModel>
  handleOnComplete: () => void
}) => {
  const [histories, formPermission] = useWatch({
    name: ['baseForm.formStatusHistories', 'baseForm.formPermission'],
    control,
  })

  return (
    <FormContainer fkey="cr-d">
      <FormSignatureHistories
        formStatusList={globalState.formStatusList}
        histories={histories}
        control={control}
        handleOnComplete={handleOnComplete}
        endOfFlow={formPermission?.endOfFlow}
        userMetaList={globalState.userMetaList}
            roleMetaList={globalState.roleMetaList}
        disabled={!formPermission?.canUpdate}
      />
    </FormContainer>
  )
}
